module.exports = __webpack_public_path__ + "img/電気回路_2_1_3.f3f024c7.png";